export default __webpack_public_path__ + "static/1-splash-423740198d598068d92a8e926ab34838.png";